import { UPCOMING_NFO, UPCOMING_NFO_ADD_MSG, UPCOMING_NFO_CLEAR_MSG, UPCOMING_NFO_ERROR, UPCOMING_NFO_HIDE_ERROR, UPCOMING_NFO_START_LOADER, UPCOMING_NFO_STOP_LOADER, } from "../interface/iUpcomingNFO";
const initState = {
    data: {
        type: null,
        list: [],
    },
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
    message: {
        msg: "",
        show: false,
        icon: "",
    },
};
const upcomingNFOReducer = (state = initState, action) => {
    switch (action.type) {
        case UPCOMING_NFO:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case UPCOMING_NFO_ADD_MSG:
            return Object.assign(Object.assign({}, state), { message: action.payload.message });
        case UPCOMING_NFO_CLEAR_MSG:
            return Object.assign(Object.assign({}, state), { message: initState.message });
        case UPCOMING_NFO_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case UPCOMING_NFO_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case UPCOMING_NFO_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case UPCOMING_NFO_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default upcomingNFOReducer;
